import { render, staticRenderFns } from "./StepPriceDialog.vue?vue&type=template&id=e2ec8eb4&scoped=true&"
import script from "./StepPriceDialog.vue?vue&type=script&lang=js&"
export * from "./StepPriceDialog.vue?vue&type=script&lang=js&"
import style0 from "./StepPriceDialog.vue?vue&type=style&index=0&id=e2ec8eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ec8eb4",
  null
  
)

export default component.exports